import { Component } from '@angular/core';
import { Leftsection } from './leftsection/leftsection';
import { Rightsection } from './rightsection/rightsection';

@Component({
  selector: 'app-forgotpassword',
  imports: [Leftsection, Rightsection],
  templateUrl: './forgotpassword.html',
  styleUrl: './forgotpassword.scss',
})
export class Forgotpassword {}
